import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getExchangeRate(from, to) {
    const ep = {
      baseURL: process.env.VUE_APP_SITE_API_ROOT,
      url: `/v1/miscs/exchange-rate?from=${from}&to=${to}`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {}, false);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
